// Bend vertex schema
// A pipe bend/elbow fitting

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema } from '../base/common';

/**
 * Bend Vertex Schema
 * A pipe bend (elbow) fitting.
 * Simple passive connection point (like junction) with additional
 * bend-specific fields for future K-value calculations.
 *
 * @property elevation - Height of the bend fitting
 * @property bend_angle - Bend angle in degrees (default 90)
 * @property bend_radius - Bend radius for K-value calculation
 */
export const BendVertexSchema = BaseVertexSchema.extend({
  type: z.literal('bend'),
  elevation: ValueWithUnitSchema,
  bend_angle: ValueWithUnitSchema.optional(), // default 90 deg
  bend_radius: ValueWithUnitSchema.optional(), // for K-value calc
});

export type BendVertex = z.infer<typeof BendVertexSchema>;
